var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParagraphOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    d: "M10.0962 20.3V29.9578C10.0962 31.2857 11.1827 32.3722 12.5106 32.3722C13.8385 32.3722 14.925 31.2857 14.925 29.9578V5.81327H19.7539V29.9578C19.7539 31.2857 20.8404 32.3722 22.1683 32.3722C23.4963 32.3722 24.5828 31.2857 24.5828 29.9578V5.81327H26.9972C28.3251 5.81327 29.4116 4.72677 29.4116 3.39882C29.4116 2.07087 28.3251 0.984375 26.9972 0.984375H10.5066C5.46044 0.984375 0.969603 4.67847 0.486713 9.70053C-0.0686069 15.4469 4.44638 20.3 10.0962 20.3L10.0962 20.3Z",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphOutlinedIcon);
export default __webpack_public_path__ + "static/media/paragraphOutlinedIcon.0c018815.svg";
export { ForwardRef as ReactComponent };